// extracted by mini-css-extract-plugin
export default {"mainContainer":"EmployersListPage_mainContainer__k15wa","schoolContainer":"EmployersListPage_schoolContainer__jUnAi","schoolImg":"EmployersListPage_schoolImg__JOrUr"};